import { BodyTypeRow } from "app/containers/BodyType/types";
import { TireTypeRow } from "app/containers/TireType/types";
import { initialListPaginationMeta } from "utils/helpers/pagination";

import {
  RegistrationForm,
  RegistrationFormDropDownState,
  RegistrationState,
} from "../types";

export const initialRegistrationForm: RegistrationForm = {
  driverCabinType: "",
  tire: "",
  suspensionType: "",
  weight: "",
  axlesMeasure: "",
  lowerLimit: "",
  upperLimit: "",
  frontLoad: "",
  rearAxlesMeasure: "",
  notes: "",
  dhType: "",
  bodyType: "",
};

export const initialRegistrationMeta = initialListPaginationMeta;

export const createFormDropDownState = <T>(): RegistrationFormDropDownState<T> => ({
  items: [],
  page: 1,
  perPage: initialListPaginationMeta.itemsPerPage,
  meta: { ...initialListPaginationMeta },
  loading: false,
});

export const initialState: RegistrationState = {
  loading: false,
  saving: false,
  list: [],
  page: 1,
  perPage: 20,
  meta: initialRegistrationMeta,
  error: null,
  driverCabinFilter: "ALL",
  axlesMeasureFilter: "ALL",
  frontLoadFilter: "ALL",
  rearAxlesMeasureFilter: "ALL",
  weightFilter: "ALL",
  tireFilter: "ALL",
  dhTypeFilter: "ALL",
  bodyTypeFilter: "ALL",
  isAddModalOpen: false,
  form: initialRegistrationForm,
  formDropDowns: {
    tires: createFormDropDownState<TireTypeRow>(),
    bodyTypes: createFormDropDownState<BodyTypeRow>(),
  },
};
